import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GridActionColumnActions } from 'src/app/interfaces/grid-action-column-actions';
import { GridActionColumnMap } from 'src/app/interfaces/grid-action-column-map';
import { AddEditSpotlightVendorRankingModalComponent } from 'src/app/modals/add-edit-spotlight-vendor-ranking-modal/add-edit-spotlight-vendor-ranking-modal.component';
import { CompanyService } from 'src/app/services/company.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-client-admin-spotlight-vendors',
  templateUrl: './client-admin-spotlight-vendors.component.html',
  styleUrls: ['./client-admin-spotlight-vendors.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ClientAdminSpotlightVendorsComponent {
  constructor(
    private ToastService: ToastService,
    private CompanyService: CompanyService,
    private ModalService: NgbModal
  ) {}

  ColumnIdToColumnActions: GridActionColumnMap = {
    ['$actionColumn']: ['edit', 'delete']
  };

  suppliedGridQueryData: { [key: string]: any } = {
    order: [['priorityLevel', 'ASC']]
  };
  reloadGrid: boolean = false;

  action({
    action,
    rowData
  }: {
    action: GridActionColumnActions;
    rowData: any;
  }) {
    const { id } = rowData;

    if (!id) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Cannot perform action. Row data has no ID.',
        { returnError: true }
      );
    }

    if (action === 'edit') {
      this.openServiceRankingEditModal(id);
    }

    if (action === 'delete') {
      this.CompanyService.deleteCompanyServiceRanking(id).subscribe({
        next: () => {
          this.ToastService.addSuccessToast(
            'Success',
            'Successfully deleted vendor ranking.'
          );
          this.reloadGrid = true;
        }
      });
    }
  }

  openServiceRankingEditModal(companyServiceRankingId?: number) {
    const modalRef = this.ModalService.open(
      AddEditSpotlightVendorRankingModalComponent,
      { centered: true, size: 'lg' }
    );
    modalRef.componentInstance.CompanyServiceRankingId =
      companyServiceRankingId;

    modalRef.closed.subscribe({
      next: () => {
        this.reloadGrid = true;
      }
    });
  }

  addRank() {
    this.openServiceRankingEditModal();
  }
}
